<template>
  <div class="staff-manage">
    <AppBar />
    <div class="page-content">
      <div class="staff-manage-canvas">
        <div class="staff-manage-background">
          <img :src="top.imgBack" alt="" />
        </div>
        <div class="por-container">
          <div class="solution-info">
            <div class="solution-info-title">{{ top.title }}</div>
            <div class="solution-info-content" v-html="top.content">
            </div>
            <div class="solution-btn" @click="openBealter">预约演示</div>
          </div>
        </div>
      </div>
      <div ref="nav" class="staff-manage-nav">
        <div ref="navTabs" class="staff-manage-nav-tabs" :style="{width: navWidth+'%', height: navHeight+'px'}">
          <div
            v-for="(item, index) in navList"
            :key="index"
            :class="['staff-manage-nav-item', topNaviId === item.id ? 'top-nav-item' : '']"
            @click="goAnchor(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div>
        <div ref="product-value" class="product-value">
          <div class="title-subtitle">
            <div class="title">产品价值分析</div>
            <div class="subtitle">帮助企业进行高效人事管理</div>
          </div>
          <div class="value-list">
            <div
              v-for="(item, index) in valueList"
              :key="index"
              class="value-list-item"
            >
              <div class="value-list-item-card-wrap">
                <div class="value-list-item-card" @mouseenter="onMouseenter(index)" @mouseleave="onMouseleve">
                  <div class="list-item-icon-wrap">
                    <img
                      v-if="valueIndex !== index"
                      :src="item.icon"
                      alt=""
                      class="list-item-icon"
                    />
                    <img
                      v-else
                      :src="item.iconChange"
                      alt=""
                      class="list-item-icon"
                    />
                  </div>
                  <div class="list-item-title">
                    {{ item.title }}
                  </div>
                  <div class="list-item-des">
                    {{ item.describe }}
                  </div>
                </div>
                <!-- <img :src="item.icon" alt="" /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="architecture" class="architecture">
          <div class="title">系统流程图</div>
          <div class="architecture-content">
            <img :src="architecture" alt="" />
          </div>
        </div>
      </div>
      <div>
        <div ref="introduction" class="introduction">
          <div class="title">系统功能介绍</div>
          <div class="introduction-tag">
            <div v-for="(item, index) in introductionTagList" :key="index" class="introduction-tag">
              <div class="introduction-tag-item" :class="{'introduction-tag-item-active': item.index === introductionTagActiveIndex}" @click="changeIntroduction(index)">
                <div>
                  <img :src="item.url" alt="" />
                </div>
                <div class="item-text">{{ item.title }}</div>
              </div>
              <div v-show="index < 3" class="introduction-tag-arrow">
                <img :src="require('@/assets/home/demand-customization7.png')" alt="" />
              </div>
            </div>
          </div>
          <transition name="introduction-fade" mode="out-in">
            <div v-if="introductionList.length != 0" :key="introductionTagActiveIndex" class="introduction-content">
              <div class="introduction-content-left" v-html="introductionList[introductionTagActiveIndex].img">
                <!-- <img :src="introductionList[introductionTagActiveIndex].img" alt="" /> -->
              </div>
              <div class="introduction-content-right">
                <div class="introduction-content-right-title">{{ introductionList[introductionTagActiveIndex].title }}</div>
                <div class="introduction-content-right-describe">{{ introductionList[introductionTagActiveIndex].describe }}</div>
                <div v-for="(item, index) in introductionList[introductionTagActiveIndex].contentList" :key="index" class="introduction-panel">
                  <img :src="require('@/assets/staffmanage/icon/liIcon.png')" alt="" />
                  <div class="introduction-panel-text">{{ item }}</div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div style="padding-top: 60px;">
        <div style="background-color: #f7f9fc;">
          <div ref="data-security" class="data-security">
            <div class="title">数据安全</div>
            <div class="data-security-content">
              <div v-for="(item, index) in dataSecurityList" :key="index" class="data-security-list-item">
                <img :src="item.icon" alt="" class="list-item-icon" />
                <div class="list-item-title">
                  {{ item.title }}
                </div>
                <div class="data-security-text">
                  <div v-for="(textItem, textIndex) in item.textList" :key="textIndex" class="list-text-item">
                    <img src="@/assets/home/content-tip.png" alt="" class="icon" />
                    <div class="text">{{ textItem }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="customer-stories">
          <div style="width: 100%; height: 60px; background-color: #f7f9fc;"></div>
          <div class="customer-stories">
            <div class="customer-stories-content">
              <div class="title">中大型企业的共同选择</div>
              <div class="customer-stories-list">
                <div v-for="(item, index) in enterpriseList" :key="index" class="cystiner-stirues-item">
                  <img :src="item" alt="" />
                </div>
              </div>
              <div class="customer-stories-btn" @click="moreEnterprise">
                <div class="btn-text">
                  查看更多案例
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="data-download" class="data-download">
          <div class="title">行业资料</div>
          <div class="data-download-content">
            <div v-for="(item, index) in dataDownloadList" :key="index" class="data-download-content-item">
              <div class="dataListTitle">{{ item.title }}</div>
              <ul class="data-list">
                <li
                  v-for="(dataItem, dataIndex) in item.dataList"
                  :key="dataIndex"
                  class="data-list-item"
                  @click="clickDate(dataItem, index)"
                >
                  <div class="data-list-left">
                    <div class="disc"></div>
                    <div class="data-title">
                      {{ dataItem.title }}
                    </div>
                  </div>
                  <div class="data-list-right">
                    <img :src="require('@/assets/icon/right-arrow.png')" alt="" />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="appointment-demonstration">
        <h4 class="appointment-demonstration-title">了解更多有关华跃产品与服务信息</h4>
        <h5 class="appointment-demonstration-subtitle">您还可以预约我们的产品演示</h5>
        <div class="appointment-demonstration-btn" @click="openBealter">
          <img :src="require('@/assets/home/appointment-demonstration1.png')" alt="" />
          <span>预约产品显示</span>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild, getColumnDetail } from '@/api/column';
import { getContentList, getContentDetail, download } from '@/api/content';
export default {
  name: 'StaffManage',
  data () {
    return {
      top: {
        title: '',
        content: '',
        imgBack: require('@/assets/staffmanage/canvas.gif'),
      },
      navWidth: 80,
      navHeight: 60,
      offsetTop: 0,
      scrollTop: 0,
      position: 0,
      navList: [
        {
          title: '产品价值',
          id: 'product-value',
        },
        {
          title: '系统架构',
          id: 'architecture',
        },
        {
          title: '功能介绍',
          id: 'introduction',
        },
        {
          title: '数据安全',
          id: 'data-security',
        },
        {
          title: '客户案例',
          id: 'customer-stories',
        },
        {
          title: '资料下载',
          id: 'data-download',
        },
      ],
      valueList: [],
      architecture: '',
      valueIndex: null,
      topNaviId: null,
      introductionTagList: [
        // {
        //   title: '预入职管理',
        //   url: require('@/assets/staffmanage/introduction-icon1.png'),
        //   index: 0,
        // },
        // {
        //   title: '证件管理',
        //   url: require('@/assets/staffmanage/introduction-icon2.png'),
        //   index: 1,
        // },
        // {
        //   title: '电子签',
        //   url: require('@/assets/staffmanage/introduction-icon3.png'),
        //   index: 2,
        // },
        // {
        //   title: '离职交接',
        //   url: require('@/assets/staffmanage/introduction-icon4.png'),
        //   index: 3,
        // },
      ],
      introductionTagActiveIndex: 0,
      introductionList: [
        // {
        //   img: require('@/assets/staffmanage/introduction-content1.png'),
        //   title: '预入职管理',
        //   describe: '大批人员入职，工作量繁重，信息不准确导致后续重复工作',
        //   contentList: [
        //     '使用扫码入职，轻松搞定信息录入',
        //     '标准格式防止信息缺失',
        //     '多层级线上审核，防止错误信息',
        //   ],
        // },
        // {
        //   img: require('@/assets/staffmanage/introduction-content2.png'),
        //   title: '预入职管理',
        //   describe: '大批人员入职，工作量繁重，信息不准确导致后续重复工作',
        //   contentList: [
        //     '使用扫码入职，轻松搞定信息录入',
        //     '标准格式防止信息缺失',
        //     '多层级线上审核，防止错误信息',
        //   ],
        // },
        // {
        //   img: require('@/assets/staffmanage/introduction-content3.png'),
        //   title: '预入职管理',
        //   describe: '大批人员入职，工作量繁重，信息不准确导致后续重复工作',
        //   contentList: [
        //     '使用扫码入职，轻松搞定信息录入',
        //     '标准格式防止信息缺失',
        //     '多层级线上审核，防止错误信息',
        //   ],
        // },
        // {
        //   img: require('@/assets/staffmanage/introduction-content4.png'),
        //   title: '预入职管理',
        //   describe: '大批人员入职，工作量繁重，信息不准确导致后续重复工作',
        //   contentList: [
        //     '使用扫码入职，轻松搞定信息录入',
        //     '标准格式防止信息缺失',
        //     '多层级线上审核，防止错误信息',
        //   ],
        // },
      ],
      dataSecurityList: [
        // {
        //   icon: require('@/assets/staffmanage/data-security1.png'),
        //   title: '身份认证',
        //   textList: [
        //     '传统用户名/密码认证',
        //     '支持动态密码安全认证方式',
        //     '支持USBE-key电子密钥安全认证方式(CA)',
        //   ],
        // },
        // {
        //   icon: require('@/assets/staffmanage/data-security2.png'),
        //   title: '安全访问',
        //   textList: [
        //     '通过授权定义用户的数据范围',
        //     '可以单独或分段设置能够登陆系统的终端，限制未授权机器访问系统',
        //     '提供针对用户访问数据的操作监视和统计，根据用户身份和应用活动进行审计',
        //   ],
        // },
        // {
        //   icon: require('@/assets/staffmanage/data-security3.png'),
        //   title: '品质保证',
        //   textList: [
        //     '十五年专注经营',
        //     '3000+企业长期合作',
        //     '大型集团化企业的首选',
        //   ],
        // },
      ],
      enterpriseList: [
      ],
      dataDownloadList: [
        {
          title: '资料下载',
          dataList: [
            {
              id: 1,
              title: '【公告】我们拥有精湛的实施工程师团队工程师团队',
            },
            {
              id: 2,
              title: '【公告】具有定制化知识与丰富经验的维丰富经验的',
            },
            {
              id: 3,
              title: '【公告】及时为客户解决在使用过程中的过程中的使',
            },
          ],
        },
        {
          title: '产品动态',
          dataList: [
            {
              id: 4,
              title: '【公告】我们拥有精湛的实施工程师团队工程师团队',
            },
            {
              id: 5,
              title: '【公告】具有定制化知识与丰富经验的维丰富经验的',
            },
            {
              id: 6,
              title: '【公告】及时为客户解决在使用过程中的过程中的使',
            },
          ],
        },
        {
          title: '干货推荐',
          dataList: [
            {
              id: 7,
              title: '【公告】我们拥有精湛的实施工程师团队工程师团队',
            },
            {
              id: 8,
              title: '【公告】具有定制化知识与丰富经验的维丰富经验的',
            },
            {
              id: 9,
              title: '【公告】及时为客户解决在使用过程中的过程中的使',
            },
          ],
        },
      ],
    };
  },
  watch: {
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue === window.scrollY) {
          for (var i = 0; i < this.navList.length; i++) {
            var elementTop = this.$refs[`${this.navList[i].id}`].offsetTop - this.scrollTop - 1;
            if (elementTop <= 70) {
              this.topNaviId = this.navList[i].id;
            }
          }
        }
      }, 20);
    },
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      const nav = this.$refs.nav;
      this.offsetTop = nav.offsetTop;
    });
    this.getPageColumn();
    this.getPartner();
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var offsetHeight = this.$refs.navTabs.offsetHeight;
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var headerFixed = this.scrollTop > this.offsetTop - offsetHeight / 2 - 70;
      var scroll = this.scrollTop - this.position;
      this.position = this.scrollTop;
      if (this.scrollTop <= 400) {
        this.navHeight = 52;
        this.navWidth = 80;
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (this.scrollTop >= 400 && !headerFixed) {
        this.navHeight += 0.04 * scroll;
        this.navWidth += 0.12 * scroll;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (headerFixed) {
        this.navHeight = 60;
        this.navWidth = 100;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'fixed';
        this.$refs.nav.style.top = (offsetHeight / 2) + 70 + 'px';
      }
    },
    goAnchor(i) {
      // var id = '#' + i.id;
      // document.querySelector(id).scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start',
      // });
      window.scrollTo({
        top: this.$refs[`${i.id}`].offsetTop - 70,
        left: 0,
        behavior: 'smooth',
      });
    },

    // 获取页面栏目
    async getPageColumn() {
      const params = { parentId: '1605834917202321408', };
      const { result, } = await getColumnChild(params);
      for (var i = 0; i < result.length; i++) {
        if (result[i].name === '产品价值') {
          const data = { columnId: result[i].id, pageNum: 1, pageSize: 10, };
          getContentList(data).then((rrs) => {
            const rrsult = rrs.result;
            for (var j = 0; j < rrsult.data.length; j++) {
              const valueItem = {
                icon: rrsult.data[j].icon,
                iconChange: rrsult.data[j].logo,
                title: rrsult.data[j].title,
                describe: rrsult.data[j].description,
              };
              this.valueList.push(valueItem);
            }
          });
        } else if (result[i].name === '系统架构') {
          getColumnDetail(result[i].id).then((rrs) => {
            this.architecture = rrs.result.icon;
          });
        } else if (result[i].name === '功能介绍') {
          const data = { columnId: result[i].id, pageNum: 1, pageSize: 10, };
          getContentList(data).then(async (rrs) => {
            const rrsult = rrs.result;
            for (var j = 0; j < rrsult.data.length; j++) {
              this.introductionTagList.push({
                title: rrsult.data[j].title,
                url: rrsult.data[j].icon,
                index: j,
              });
              const rts = await getContentDetail(rrsult.data[j].id);
              const rtsult = rts.result;
              const doc = new DOMParser().parseFromString(rtsult.defaultContent, 'text/html');
              const introduction = {
                img: doc.documentElement.textContent.replace(/&nbsp;/g, ' '),
                title: rtsult.title,
                describe: rtsult.description,
                contentList: [],
              };
              for (var x = 0; x < rtsult.elements.length; x++) {
                introduction.contentList.push(rtsult.elements[x].content);
              }
              this.introductionList.push(introduction);
            }
          });
        } else if (result[i].name === '数据安全') {
          getContentList({ columnId: result[i].id, pageNum: 1, pageSize: 99, }).then(async (rrs) => {
            const rrsult = rrs.result;
            for (var j = 0; j < rrsult.data.length; j++) {
              const rts = await getContentDetail(rrsult.data[j].id);
              const rtsult = rts.result;
              var dataSecurityItem = {
                icon: rtsult.icon,
                title: rtsult.title,
                textList: [],
              };
              for (var x = 0; x < rtsult.elements.length; x++) {
                dataSecurityItem.textList.push(rtsult.elements[x].content);
              }
              this.dataSecurityList.push(dataSecurityItem);
            }
          });
        } else if (result[i].name === '顶部图') {
          getColumnDetail(result[i].id).then((rrs) => {
            const rrsult = rrs.result;
            var content = rrsult.elements.find(obj => obj.name === 'content').content;
            var contentdoc = new DOMParser().parseFromString(content, 'text/html');
            this.top.title = rrsult.elements.find(obj => obj.name === 'subtitle').content;
            this.top.content = contentdoc.documentElement.textContent.replace(/&nbsp;/g, ' ');
            // this.top = {
            //   imgBack: rrsult.icon,
            // };
          });
        }
      }
      const downLoadParams = { columnId: '1605494229646401536', pageNum: 1, pageSize: 4, commendation: 9, cascade: true, };
      getContentList(downLoadParams).then(async (res) => {
        const { result, } = res;
        this.dataDownloadList[0].dataList = result.data;
      });
      const contentParams = { columnId: '1605774350588534784', pageNum: 1, pageSize: 4, commendation: 9, };
      getContentList(contentParams).then(async (res) => {
        const { result, } = res;
        this.dataDownloadList[1].dataList = result.data;
      });
      const industryParams = { columnId: '1605774444985540608', pageNum: 1, pageSize: 4, commendation: 9, };
      getContentList(industryParams).then(async (res) => {
        const { result, } = res;
        this.dataDownloadList[2].dataList = result.data;
      });
    },

    // 合作伙伴列表
    getPartner() {
      var params = { columnId: '1605405080163672064', pageNum: 1, pageSize: 18, commendation: 16, cascade: true, };
      getContentList(params).then((res) => {
        const { result, } = res;
        for (var i = 0; i < result.data.length; i++) {
          this.enterpriseList.push(result.data[i].logo);
        }
      });
    },

    clickDate(data, index) {
      if (index === 0) {
        getContentDetail(data.id).then((res) => {
          const { result, } = res;
          var file = result.elements.find(obj => obj.name === 'file').content;
          download(file[0].url).then((rrs) => {
            const fileName = file[0].name;
            const blob = new Blob([ rrs.data, ]);
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
              // 兼容window.navigator.msSaveBlob：以本地方式保存文件
              window.navigator.msSaveBlob(blob, decodeURI(fileName));
            } else {
              // 创建新的URL并指向File对象或者Blob对象的地址
              const blobURL = window.URL.createObjectURL(blob);
              // 创建a标签，用于跳转至下载链接
              const tempLink = document.createElement('a');
              tempLink.style.display = 'block';
              tempLink.href = blobURL;
              tempLink.setAttribute('download', decodeURI(fileName));
              // 兼容：某些浏览器不支持HTML5的download属性
              if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank');
              }
              // 挂载a标签
              document.body.appendChild(tempLink);
              tempLink.click();
              document.body.removeChild(tempLink);
              // 释放blob URL地址
              window.URL.revokeObjectURL(blobURL);
            }
          });
        });
      } else if (index === 1) {
        this.$router.push({ path: `/news/details/${data.id}`, query: { type: 1, }, });
      } else if (index === 2) {
        this.$router.push({ path: `/news/details/${data.id}`, query: { type: 2, }, });
      }
    },

    onMouseenter(i) {
      this.valueIndex = i;
    },
    onMouseleve() {
      this.valueIndex = null;
    },
    changeIntroduction (index) {
      this.introductionTagActiveIndex = index;
    },
    moreEnterprise () {
      this.$router.push({ name: 'CustomerCase', });
    },
    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style>
:root{
  --minwidth: 1200px
}
</style>
<style lang="less" scoped>
.staff-manage{
  background-color: #fff;
  .page-content{
    width: 100%;
    // position: relative;
    .staff-manage-canvas{
      width: 100%;
      height: fit-content;
      min-width: var(--minwidth);
      position: relative;
      background-size: cover;
      overflow: hidden;
      .staff-manage-background{
        // width: 100%;
        // height: 560px;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // object-fit: cover;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
        }
      }
      .por-container {
          width: 85%;
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          .solution-info {
            width: 540px;
            height: 560px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            box-sizing: border-box;
            .solution-info-title {
              font-size: 45px;
              font-weight: bold;
              line-height: 55px;
              color: #181818;
              margin-bottom: 30px;
            }
            .solution-info-content {
              font-size: 20px;
              line-height: 32px;
              color: #7b7b7b;
              margin-bottom: 44px;
            }
            .solution-btn {
              width: 142px;
              height: 48px;
              background-color: #00b0dc;
              color: #fff;
              text-align: center;
              line-height: 48px;
              cursor: pointer;
              border-radius: 24px;
            }
          }
        }
    }
    .staff-manage-nav {
      width: 100%;
      display: flex;
      position: relative;
      justify-content: center;
      z-index: 50;
      .staff-manage-nav-tabs{
        // min-width: var(--minwidth);
        // max-width: 100%;
        margin: 0 auto;
        // min-width: var(--minwidth);
        box-shadow: 0px 2px 8px 0px rgba(139, 139, 139, 0.18);
        border-radius: 2px;
        background-color: #fff;
        display: flex;
        position: absolute;
        // left: 0;
        top: -26px;
        // transition: height .5s;
        .staff-manage-nav-item{
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #181818;
          font-size: 14px;
          cursor: pointer;
        }
        .staff-manage-nav-item:hover{
          color: #00b0dc;
        }
        .top-nav-item {
          color: #ffffff;
          background-color: #00b0dc;
        }
        .top-nav-item:hover {
          color: #fff;
        }
      }
    }
    .product-value{
      width: 70%;
      min-width: var(--minwidth);
      padding-top: 116px;
      margin: 0 auto;
      background-color: #fff;
      box-sizing: border-box;
      .title-subtitle{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 64px;
        .title{
          font-size: 32px;
          color: #181818;
          line-height: 1;
        }
        .subtitle{
          font-size: 16px;
          color: #7b7b7b;
          margin-top: 23px;
          line-height: 1;
        }
      }
      .value-list{
        width: 100%;
        display: flex;
        align-items: center;
        .value-list-item{
          flex: 1;
          height: 322px;
          .value-list-item-card-wrap{
            display: flex;
            align-items: center;
            height: 100%;
            width: 100%;
            .value-list-item-card{
              width: 100%;
              height: 250px;
              background-color: #f5f5f5;
              color: #181818;
              width: 100%;
              transition: all .3s ease-in-out;
              padding: 50px 33px 48px 30px;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              .list-item-icon-wrap{
                height: 24px;
                width: 100%;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .list-item-icon{
                  width: auto;
                  height: 24px;
                  opacity: 1;
                  display: block;
                }
              }
              .list-item-title{
                padding: 19px 0;
                font-weight: 500;
                font-size: 18px;
                line-height: 1;
              }
              .list-item-des{
                width: 100%;
                flex: 1;
                color: #757575;
                font-size: 14px;
                margin-bottom: 15px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                text-overflow: ellipsis;
                transition: all .3s ease-in-out;
              }
            }
            .value-list-item-card:hover{
              height: 100%;
              // background: url('@/assets/staffmanage/value-background.png') no-repeat;
              background-color: #00b0dc;
              background-size: cover;
              color: #fff;
              box-shadow: 0px 4px 15px 1px rgba(158, 157, 157, 0.59);
              .list-item-des{
                color: #fff;
                display: block;
              }
            }
          }
        }
      }
    }
    .architecture{
      width: 1200px;
      padding-top: 119px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
      }
      .architecture-content{
        width: 100%;
        img{
          width: 100%;
        }
      }
    }
    .introduction{
      width: 1200px;
      padding-top: 109px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        padding-bottom: 70px;
        box-sizing: border-box;
      }
      .introduction-tag{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        .introduction-tag-item{
          text-align: center;
          margin: 0 25px;
          cursor: pointer;
          color: #6d6e6f;
          img{
            display: flex;
          }
          .item-text{
            line-height: 1;
          }
          &:hover{
            color: #00b0dc;
          }
        }
        .introduction-tag-item-active{
          color: #00b0dc;
        }
        .introduction-tag-arrow{
          img{
            margin-bottom: 75px;
            display: flex;
          }
        }
      }
      .introduction-tag:nth-child(1){
        .introduction-tag-item{
          img{
            transform: translateY(4px);
          }
          &:hover{
            img{
              transform: translateY(4px) scale(1.1);
            }
          }
        }
      }
      .introduction-tag:nth-child(2){
        .introduction-tag-item{
          img{
            transform: translateY(5px);
          }
          &:hover{
            img{
              transform: translateY(5px) scale(1.1);
            }
          }
        }
      }
      .introduction-tag:nth-child(3){
        .introduction-tag-item{
          img{
            transform: translateY(13px);
          }
          &:hover{
            img{
              transform: translateY(13px) scale(1.1);
            }
          }
        }
      }
      .introduction-tag:nth-child(4){
        .introduction-tag-item{
          img{
            transform: translateY(4px);
          }
          &:hover{
            img{
              transform: translateY(4px) scale(1.1);
            }
          }
        }
      }
      .introduction-content{
        display: flex;
        justify-content: space-between;
        margin-top: 80px;
        width: 100%;
        height: 425px;
        .introduction-content-left{
          height: 100%;
          img{
            width: auto;
            height: 100%;
          }
        }
        .introduction-content-right{
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          padding-top: 85px;
          .introduction-content-right-title{
            font-size: 28px;
            font-weight: 500;
            color: #181818;
            line-height: 1;
            margin-bottom: 15px;
          }
          .introduction-content-right-describe{
            font-size: 16px;
            color: #7b7b7b;
            line-height: 1;
            margin-bottom: 46px;
          }
          .introduction-panel{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 36px;
            img{
              width: 24px;
              height: auto;
            }
            .introduction-panel-text{
              font-size: 16px;
              color: #181818;
              line-height: 1;
              margin-left: 8px;
            }
          }
        }
      }
    }
    .introduction-fade-enter-active {
      animation: bounce-in 1.3s;
    }
    .introduction-fade-leave-active {
      animation: bounce-in .5s reverse;
    }
    @keyframes bounce-in {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    .data-security{
      width: 70%;
      min-width: var(--minwidth);
      padding-top: 70px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
      }
      .data-security-content{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 70px;
        .data-security-list-item{
          width: 318px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          .list-item-icon{
            width: auto;
            height: 117px;
            margin-bottom: 7px;
          }
          .list-item-title{
            font-size: 18px;
            color: #181818;
            font-weight: 500;
            margin-bottom: 35px;
          }
          .data-security-text{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            .list-text-item{
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              margin-bottom: 32px;
              .icon{
                margin-top: 3px;
              }
              .text{
                font-size: 16px;
                color: #181818;
                margin-left: 16px;
              }
            }
          }
        }
      }
    }
    .customer-stories{
      width: 100%;
      min-width: 1200px;
      display: flex;
      flex-direction: column;
      background: url('@/assets/staffmanage/customer-back.png') no-repeat;
      background-position: center;
      background-size: cover;
      background-position: center;
      height: 561px;
      padding: 69px 0 60px;
      box-sizing: border-box;
      .customer-stories-content{
        width: 80%;
        min-width: var(--minwidth);
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        .title{
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 32px;
          font-weight: 500;
          color: #181818;
          margin-bottom: 70px;
        }
        .customer-stories-list{
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          .cystiner-stirues-item{
            width: calc(16.666% - 20px);
            height: 70px;
            margin: 10px;
            background-color: #fff;
            border: solid 1px #dfdfdf;
            display: flex;
            box-sizing: border-box;
            justify-content: center;
            align-items: center;
            padding: 10px;
            img{
              width: 100%;
              height: 100%;
              object-fit: contain;
              display: block;
            }
          }
        }
        .customer-stories-btn{
          width: 155px;
          height: 50px;
          background-color: #00b0dc;
          border-radius: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 20px;
          cursor: pointer;
          .btn-text{
            font-size: 15px;
            color: #ffffff;
          }
          &:hover{
            transform: scale(1.1);
            transition: all  0.5s;
          }
        }
      }
    }
    .data-download{
      width: 70%;
      min-width: 1209px;
      padding-top: 70px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-bottom: 100px;
      .title{
        font-size: 32px;
        color: #181818;
      }
      .data-download-content{
        display: flex;
        margin: 70px auto 0;
        .data-download-content-item{
          width: 386px;
          height: 250px;
          margin-right: 21px;
          padding: 31px 32px 0 28px;
          background: url('@/assets/staffmanage/download-back.png') center;
          background-size: cover;
          box-sizing: border-box;
          .dataListTitle{
            font-size: 18px;
            color: #181818;
            line-height: 1;
            margin-bottom: 14px;
          }
          .data-list{
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            .data-list-item{
              width: 100%;
              display: flex;
              justify-content: space-between;
              margin-top: 14px;
              // padding-left: 24px;
              box-sizing: border-box;
              list-style:disc;
              .data-list-left{
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .disc{
                  width: 4px;
                  height: 4px;
                  border-radius: 50%;
                  background-color: #000;
                }
                .data-title{
                  width: 254px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  font-size: 14px;
                  color: #181818;
                  cursor: pointer;
                  position: relative;
                  margin-left: 20px;
                }
              }
              .data-list-right{
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                  width: auto;
                  height: 10px;
                  display: block;
                }
                display: none;
              }
            }
            .data-list-item:hover{
              .data-list-left{
                .disc{
                  background-color: #00b0dc;
                }
                .data-title{
                  color: #00b0dc;
                }
              }
              .data-list-right{
                display: block;
              }
            }
          }
        }
        .data-download-content-item:last-child{
          margin-right: 0;
        }
      }
    }
    .appointment-demonstration{
      width: 100%;
      min-width: var(--minwidth);
      height: 188px;
      background-image: url('@/assets/home/appointment-demonstration.png');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      text-align: center;
      color: #fff;
      padding: 22px;
      box-sizing: border-box;
      .appointment-demonstration-title{
        font-size: 26px;
        color: #fff;
        margin-bottom: 20px;
      }
      .appointment-demonstration-subtitle{
        font-size: 16px;
        font-weight: 400;
        color: #fff;
        margin-bottom: 25px;
      }
      .appointment-demonstration-btn{
        width: 220px;
        height: 46px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: auto;
        background: #00b0dc;
        border-radius: 30px;
        cursor: pointer;
        img{
          width: 18px;
          height: 22px;
          vertical-align: middle;
          margin-right: 10px
        }
        transition: all 0.5s;
        &:hover{
          transform: scale(1.1);
          transition: all  0.5s;
        }
      }
    }
  }
}
</style>
